import { apiV2 } from './api';

export const fetchProduct = (slug) => apiV2.get(`/products/${slug}/`);
export const fetchProductDetail = (slug) => apiV2.get(`/products/${slug}/details/`);
export const fetchProducts = () => apiV2.get('/products/');
